import React from 'react';
import {usePM10FilterById} from "../../../../../../sdk/queries";
import {SimpleRow} from "../../../../../800CallLogs/components/SimpleRow";
import {LineMark} from '../../../../../800CallLogs/styles';
import {Modal, ModalProps} from "../../../../../Modal";
import {useAQM} from "../../../../context";
import {AQICode} from "./components/AQICode";
import {SubRow} from "./components/SubRow";
import { Note, SubRowGroup } from './styles';

export type DataDetailsModalProps = {
    dataId?: number;
} & ModalProps;


const getDeltaWeight = (a: number | null | undefined, b: number | null | undefined):number | null | undefined => {
    if(typeof b === "number" && typeof a === "number") {
        return b - a;
    }
    return null;
};

export const DataDetailsModal: React.VFC<DataDetailsModalProps> = ({
    dataId,
    ...props
}) => {

    const {
        currentLocation,
    } = useAQM();

    const {data, loading} = usePM10FilterById({
        skip: typeof dataId !== "number",
        variables: {
            id: String(dataId),
        }
    });

    const pm10Filter = data?.data;



    return (
        <Modal title={"Data Details"} {...props}>
            <div>
                {loading ? "Getting details..." : (
                    <React.Fragment>
                        <SimpleRow label={"Sampling Location"} value={currentLocation?.name} fullWidth/>
                        <LineMark/>
                        <SimpleRow label={"Sampling Date"} value={pm10Filter?.exposureOn} fullWidth/>
                        <LineMark/>
                        <SimpleRow label={"Concentration (µg/m³)"} value={pm10Filter?.concentration?.toFixed(2)} fullWidth/>
                        <LineMark/>
                        <SimpleRow label={"Exceeds NAAQS?"} value={(pm10Filter?.concentration ?? 0) > 150 ? "YES" : "NO"} fullWidth/>
                        <LineMark/>
                        <SimpleRow label={"AQI Code"} value={<AQICode value={pm10Filter?.concentration ?? 0}/>} fullWidth/>
                        <LineMark/>
                        <SimpleRow titleCentered={false} label={"Filter Information"} value={(
                            <SubRowGroup>
                                <SubRow name={"Pre-Weight (g)"} value={pm10Filter?.preWeight?.toFixed(4)}/>
                                <SubRow name={"Post-Weight (g)"} value={pm10Filter?.postWeight?.toFixed(4)}/>
                                <SubRow name={"Delta Weight (g)"} value={getDeltaWeight(pm10Filter?.preWeight, pm10Filter?.postWeight)?.toFixed(4)}/>
                            </SubRowGroup>
                        )} fullWidth/>
                        <LineMark/>
                        <SimpleRow titleCentered={false} label={"Sampler Information"} value={(
                            <SubRowGroup>
                                <SubRow name={"Flow Rate (ft3/min)"} value={pm10Filter?.flowRate?.toFixed(2)}/>
                                <SubRow name={"Run Time (min)"} value={pm10Filter?.runTime?.toFixed(0)}/>
                                <Note>*Flow rate adjusted to standard atmosphere (760 mmHg and 25 C)</Note>
                            </SubRowGroup>
                        )} fullWidth/>
                        <LineMark/>
                        <SimpleRow titleCentered={false} label={"Local Weather Information"} value={(
                            <SubRowGroup>
                                <SubRow name={"Site Temperature (Day Average, °F)"} value={pm10Filter?.postSiteTemp?.toFixed(2)}/>
                                <SubRow name={"Site Pressure (in Hg)"} value={pm10Filter?.postSitePressure?.toFixed(2)}/>
                                <SubRow name={"Precipitation (in)"} value={pm10Filter?.precipitation?.toFixed(2)}/>
                                <Note>*Weather data obtained from Norfolk International Airport Station (KORF)</Note>
                            </SubRowGroup>
                        )} fullWidth/>
                        <LineMark/>
                        <SimpleRow titleCentered={false} label={"Comments"} value={pm10Filter?.comments} fullWidth/>
                    </React.Fragment>
                )}
            </div>
        </Modal>
    );
};